<template>
	<div class="resource" v-if="resource">
		<div class="content-box-padding">
			<div
				class="resource-intro-text margin-bottom-xs-2"
				v-if="resource.intro_text"
				v-html="resource.intro_text"
			></div>

			<ResourceTypeVideo v-if="resource.resource_type == 'video'" />
			<ResourceTypeLink v-if="resource.resource_type == 'link'" />
			<ResourceQuestion
				v-for="question in resource.questions"
				:question="question"
				:key="question.id"
			/>
			<div class="mt-3" v-if="moduleMessages.length">
				<Message
					v-for="message in moduleMessages"
					:text="message.text"
					:type="message.type"
					:key="message.text"
					:showCloseIcon="false"
				/>
			</div>
			<div class="row align-items-center">
				<div class="col-auto col-md-auto">
					<a
						class="text-small text-decoration-none d-inline-flex align-items-center"
						href="#"
						@click.prevent="goToPreviousModule"
						><Icon
							class="margin-right-xs-1 icon-17"
							:icon="'arrow-thin-left'"
						/>
						Tillbaka</a
					>
				</div>
				<div class="col col-md text-right">
					<a
						@click.prevent="saveResourceAnswers"
						href="#"
						class="pem-btn pem-btn-secondary"
						:class="{
							'loading loading-icon-white': isLoading,
							disabled: !canSaveAnswers,
							'pem-btn-success': canSaveAnswers
						}"
					>
						Spara och gå vidare
						<Icon
							class="margin-left-xs-1 icon-white"
							:icon="'arrow-thin-right'"
						/>
					</a>
				</div>
			</div>
			<p
				v-if="!canSaveAnswers && true == false"
				class="text-center text-muted mt-3 mb-0"
			>
				Du måste svara på alla frågor innan du kan gå vidare.
			</p>
		</div>
	</div>
</template>
<script>
import ResourceTypeLink from "./ResourceTypeLink.vue";
import ResourceTypeVideo from "./ResourceTypeVideo.vue";
import ResourceQuestion from "./ResourceQuestion.vue";
import Message from "./../partials/Message.vue";
import Icon from "./../partials/Icon.vue";
export default {
	name: "Resource",
	props: [],
	components: {
		ResourceTypeLink,
		ResourceTypeVideo,
		ResourceQuestion,
		Message,
		Icon
	},
	computed: {
		resource() {
			return this.$store.state.activeResource;
		},
		isLoading() {
			return this.$store.state.isLoading;
		},
		moduleMessages() {
			return this.$store.state.messages.module;
		},
		canSaveAnswers() {
			for (var i in this.$store.state.activeResource.questions) {
				var question = this.$store.state.activeResource.questions[i];
				if (
					question.user_answer == null ||
					question.user_answer.answer == ""
				) {
					return false;
				}
				/* Check if user has answered the "correct" answer, if there is one */
				for (var x in question.answers) {
					var answer = question.answers[x];
					if (answer.correct_answer) {
						if (
							answer.answer_id != question.user_answer.answer_id
						) {
							return false;
						}
					}
				}
			}
			return true;
		}
	},
	methods: {
		saveResourceAnswers() {
			if (!this.canSaveAnswers) {
				return;
			}
			this.$store.dispatch("saveResourceAnswers");
		},
		goToPreviousModule() {
			this.$store.dispatch("goToPreviousModule");
			this.$store.dispatch("scrollToAppTop");
		}
	},
	mounted() {}
};
</script>